import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { SetStateCode, type SetStateCodeMutation, type SetStateCodeMutationVariables } from './api.graphql';

export type SetStateCodeInput = SetStateCodeMutationVariables['input'];

export async function setStateCode(
	{ stateCode }: { stateCode: string },
	{ gql: { fetch } }: UtilityContext,
): Promise<boolean> {
	const result = await fetch<SetStateCodeMutation, SetStateCodeMutationVariables>({
		query: SetStateCode,
		variables: {
			input: {
				stateCode,
			},
		},
		rejectOnError: false,
	});

	return !!result.data?.setStateCode.success;
}
